<template>
  <MainCard>
    <template v-slot:body>
      <v-tabs
        v-model="tab"
        show-arrows
        fixed-tabs
      >
        <v-tab
          v-for="(tabItem,index) in tabs"
          :key="tabItem.title"
          @click="reRenderComponent(index)"
        >
          <span>{{ tabItem.title }}</span>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <attendance-recap :key="componentKey"></attendance-recap>
        </v-tab-item>
        <v-tab-item>
          <attendance-qr-code :key="componentKey1"></attendance-qr-code>
        </v-tab-item>
      </v-tabs-items>
    </template>
  </MainCard>
</template>

<script>
import MainCard from '@/views/components/MainCard.vue'
import AttendanceQrCode from './AttendanceQrCode.vue'
import AttendanceRecap from './AttendanceRecap.vue'

export default {
  name: 'Attendance',
  components: {
    AttendanceRecap,
    MainCard,
    AttendanceQrCode,
  },
  data() {
    return {
      tab: '',
      tabs: [{ title: 'Rekap Absensi' }, { title: 'QR Code' }],
      componentKey: 0,
      componentKey1: 0,
    }
  },
  methods: {
    reRenderComponent(index) {
      switch (index) {
        case 0:
          this.componentKey += 1
          break
        case 1:
          this.componentKey1 += 1
          break
        default:
          break
      }
    },
  },
}
</script>

<style>
</style>
